// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: an agent thread's title as plain text. A thread started without a title is named after
// the first line of its prompt, so a prompt that opens with `- **Files.** Browse…` used to show
// its Markdown in the list, cards and notifications. The bridge names new threads the same way
// (konvo_agents/src/titles.ts); keep the two in step.

const LINE_PREFIX = /^(?:\s*(?:#{1,6}\s+|>\s*|[-*+•]\s+|\d{1,3}[.)]\s+|\[[ xX]?\]\s+))+/;
const INLINE: ReadonlyArray<[RegExp, string]> = [
	[/!\[([^\]]*)\]\([^)]*\)/g, '$1'],
	[/\[([^\]]+)\]\([^)]*\)/g, '$1'],
	[/<((?:https?:\/\/|mailto:)[^>\s]+)>/g, '$1'],
	[/`+([^`]+?)`+/g, '$1'],
	[/\*\*([^*]+?)\*\*/g, '$1'],
	[/__([^_]+?)__/g, '$1'],
	[/~~([^~]+?)~~/g, '$1'],
	[/(?<![\w*])\*([^*\s](?:[^*]*?[^*\s])?)\*(?![\w*])/g, '$1'],
	[/(?<![\w_])_([^_\s](?:[^_]*?[^_\s])?)_(?![\w_])/g, '$1'],
	// What a title cut mid-way leaves open.
	[/\*\*|~~|`{3,}/g, ''],
];

export function plainAgentTitle(title: string): string {
	let text = title.replace(/\s+/g, ' ').trim().replace(LINE_PREFIX, '');
	for (const [pattern, replacement] of INLINE) text = text.replace(pattern, replacement);
	text = text.replace(/\s+/g, ' ').trim();
	return text || title.trim();
}
